import { makeHtmlNodeToJsxPrinter, textNodeToJsxPrinter, allHtmlParsers, parseChildren } from '@utils/ast';

const parseIGuideHtmlNode = (node, context) => {
  const attributes = Object.fromEntries(Array.from(node.attributes).map(it => [it.nodeName, it.nodeValue]).filter(it => it[1] !== null));
  const children = parseChildren(node, {
    ...iGuideHtmlNodeParsers
  }, context.depth + 1);
  const tagName = node.tagName.toLowerCase();

  /**
   * Add a parser that can transform legacy <a class="flowplayer-..." />-tags
   * used to embed audio and video files into modern <audio />- and <video
   * />-tags.
   */
  const transformedTagName = (() => {
    if (tagName === "a") {
      if (node.classList.contains("flowplayer-video")) {
        return "video";
      }
      if (node.classList.contains("flowplayer-audio")) {
        return "audio";
      }
    }
    return tagName;
  })();
  return {
    nodeType: "html",
    tagName: transformedTagName,
    attributes: Object.keys(attributes).length > 0 ? attributes : undefined,
    children: children.length > 0 ? children : undefined
  };
};
const iGuideHtmlNodeParsers = {
  ...Object.fromEntries(Object.keys(allHtmlParsers).map(key => [key, parseIGuideHtmlNode])),
  iframe: parseIGuideHtmlNode
};
const htmlNodeToJsxPrinter = makeHtmlNodeToJsxPrinter();
const flashcardHtmlNodePrinters = {
  text: textNodeToJsxPrinter,
  html: htmlNodeToJsxPrinter
};

export { flashcardHtmlNodePrinters, htmlNodeToJsxPrinter, iGuideHtmlNodeParsers, parseIGuideHtmlNode };
//# sourceMappingURL=spec.html.js.map
